/**
 * Persisted user preferences. Stored per-origin in localStorage so the
 * settings stick across visits — but each site keeps its own key so
 * settings don't leak between sites that all happen to use uniqu.
 */
const STORAGE_KEY = "uniqu:prefs:v1";

export interface Prefs {
  active: Record<string, boolean>;
  fontScale: number;
  /** Currently applied accessibility profile id, if any. */
  profile?: string;
  /** Set once we've honoured the visitor's OS accessibility settings. */
  osApplied?: boolean;
}

const DEFAULTS: Prefs = { active: {}, fontScale: 1 };

export function loadPrefs(): Prefs {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULTS, ...parsed };
  } catch {
    return { ...DEFAULTS };
  }
}

export function savePrefs(p: Prefs) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(p));
  } catch {
    // localStorage can be blocked (private mode, strict CSP) — settings
    // just don't persist. The widget still works for the session.
  }
}

export function resetPrefs() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
}
